/*
 * Vremou scroll-reveal
 * ---------------------------------------------------------------
 * Laat elementen rustig verschijnen zodra ze in beeld komen.
 * Zonder JavaScript of bij 'beperk beweging' is alles gewoon
 * meteen zichtbaar - de inhoud is nooit afhankelijk van dit script.
 */

(function () {
  const SELECTOR = '[data-vr-reveal]';

  function revealAll() {
    document.querySelectorAll(SELECTOR).forEach((el) => el.setAttribute('data-vr-shown', ''));
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-vr-shown', '');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function observe() {
    document.querySelectorAll(`${SELECTOR}:not([data-vr-shown])`).forEach((el) => observer.observe(el));
  }

  observe();

  // De Theme Editor rendert secties opnieuw; die opnieuw meenemen.
  document.addEventListener('shopify:section:load', observe);
})();
